// extracted by mini-css-extract-plugin
module.exports = {"title":"CreatorsSection_title__Jyx5E","result":"CreatorsSection_result___4iTM"};